import { actionCreator } from '@ardoq/rxbeach';
import { ChartWindowArgs } from '@ardoq/graph';
import { POPOVER_ELEMENT_TYPE } from './consts';

export type CollapseExpandGroupPayload = {
  rawItemIdPath: string;
  isCollapsed: boolean;
};
export type CollapseExpandAllGroupsPayload = {
  isCollapsed: boolean;
};

export const collapseExpandGroup = actionCreator<CollapseExpandGroupPayload>(
  '[Timelines] COLLAPSE_EXPAND_GROUP'
);
export const collapseExpandAllGroups =
  actionCreator<CollapseExpandAllGroupsPayload>(
    '[Timelines] COLLAPSE_EXPAND_ALL_GROUPS'
  );

export const collapseExpandFieldData =
  actionCreator<CollapseExpandGroupPayload>(
    '[Timelines] COLLAPSE_EXPAND_FIELD_DATA'
  );
export const collapseExpandAllFieldData =
  actionCreator<CollapseExpandAllGroupsPayload>(
    '[Timelines] COLLAPSE_EXPAND_ALL_FIELD_DATA'
  );

export type SetHoveredItemPayload = {
  hoveredItemId: string | null;
};
export const setHoveredItem = actionCreator<SetHoveredItemPayload>(
  '[Timelines] SET_HOVERED_ITEM'
);
export type SetFocusedItemPayload = {
  focusedItemId: string | null;
};
export const setFocusedItem = actionCreator<SetFocusedItemPayload>(
  '[Timelines] SET_FOCUSED_ITEM'
);

export const setChartWindowState = actionCreator<ChartWindowArgs>(
  '[Timelines] SET_CHART_WINDOW_STATE'
);
export type SetUserDefinedLabelsColumnWidthPayload = {
  userDefinedLabelsColumnWidth: number | null;
};
export const setUserDefinedLabelsColumnWidth =
  actionCreator<SetUserDefinedLabelsColumnWidthPayload>(
    '[Timelines] SET_USER_DEFINED_LABELS_COLUMN_WIDTH'
  );

// We separate resize active and inactive actions because we need to
// debounce when the resize is deactivated
export const setResizeIsActive = actionCreator(
  '[Timelines] SET_RESIZE_IS_ACTIVE'
);
export const setResizeIsInactive = actionCreator(
  '[Timelines] SET_RESIZE_IS_INACTIVE'
);

export type SetTimelineMouseHoverPayload = {
  crosshairXPosition: number;
  graphNodeId: string | null;
  itemPhasesRowIndex: number | null;
  otherLabelIndex: number | null;
  popoverElementType: POPOVER_ELEMENT_TYPE | null;
  popoverY: number;
  popoverX: number;
};
export const setTimelineMouseHover =
  actionCreator<SetTimelineMouseHoverPayload>('[Timelines] SET_MOUSE_HOVER');
export type SetTimelineChartWindowScrollPositionPayload = {
  scrollLeft: number;
};
export const setTimelineChartWindowScrollPosition =
  actionCreator<SetTimelineChartWindowScrollPositionPayload>(
    '[Timelines] SET_TIMELINE_CHART_WINDOW_SCROLL_POSITION'
  );
export type ChartAreaScrollTopPayload = {
  scrollTop: number;
};
export const chartAreaScrollTopChanged =
  actionCreator<ChartAreaScrollTopPayload>(
    '[Timelines] CHART_AREA_SCROLL_TOP_CHANGED'
  );
